/**
 * THEME LINKPICK
 */

import { combine } from "../../utils/styles";

export const spacing = (factor) => {
  return `${8 * factor}px`;
};

export const fontSizes = (size) => {
  if (window.innerWidth < 768) {
    return 0.9 * size;
  }
  if (window.innerWidth < 1440) {
    return 0.75 * size;
  }
  if (window.innerWidth < 1280) {
    return 0.67 * size;
  } else return size;
}; 

const colors2 = {
  // Bleus
  bleuElectrique: '#0060F9',      
  bleuMarine:     '#152652',    
  bleuArdoise:    '#5D75A8',    
  bleuPale:       '#C0D9FF',  
  bleuSaphir:     '#004AC1',
  
  // Blancs
  blancGlacial: '#F3F7FF',       
  blancGlacier: '#92ABD2',       
  
  // Verts
  vertAmande:  '#DBFAD8',        
  vertProfond: '#008000',        
  
  // Roses , Rouges, Violet
  rosePoudre:     '#FBD3D5',     
  roseElectrique: '#F50057',    
  roseGuimauve:   '#FAD7EE',     
  lavandeDouce:   '#E9D5FB',     
  violetIntense:  '#8631D6',     
  fuchsiaRoyale:  '#C2278C',     
  framboiseRubis: '#BD0042',     
  
  // Orange
  beigeVanille:     '#FAE8D7',     
  orangeFlamboyant: '#FA8100',     

  blanc: '#FFFFFF',
};

const fontSizes2 = {
  // paragraphes
  body: {
    '@media only screen and (max-width:1920px)': { fontSize: '14px' },
    '@media only screen and (max-width:1543px)': { fontSize: '13.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '13px' },
    '@media only screen and (max-width:810px)': { fontSize: '12.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '12px' }
  },
  bodyMd: {
    '@media only screen and (max-width:1920px)': { fontSize: '15px' },
    '@media only screen and (max-width:1543px)': { fontSize: '14.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '14px' },
    '@media only screen and (max-width:810px)': { fontSize: '13.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '13px' }
  },
  bodyLg: {
    '@media only screen and (max-width:1920px)': { fontSize: '16px' },
    '@media only screen and (max-width:1543px)': { fontSize: '15.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '15px' },
    '@media only screen and (max-width:810px)': { fontSize: '14.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '14px' }
  },

  // titres
  h2: {
    '@media only screen and (max-width:1920px)': { fontSize: '18px' },
    '@media only screen and (max-width:1543px)': { fontSize: '17.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '17px' },
    '@media only screen and (max-width:810px)': { fontSize: '16.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '16px' }
  },
  h2Lg: {
    '@media only screen and (max-width:1920px)': { fontSize: '20px' },
    '@media only screen and (max-width:1543px)': { fontSize: '19.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '19px' },
    '@media only screen and (max-width:810px)': { fontSize: '18.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '18px' }
  },
  h1: {
    '@media only screen and (max-width:1920px)': { fontSize: '24px' },
    '@media only screen and (max-width:1543px)': { fontSize: '23.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '23px' },
    '@media only screen and (max-width:810px)': { fontSize: '22.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '22px' }
  },
};

const iconSizes = {
  // icônes
  iconSm: {
    '@media only screen and (max-width:1920px)': { fontSize: '16px', width: '16px', height: '16px' },
    '@media only screen and (max-width:1543px)': { fontSize: '15.5px', width: '15.5px', height: '15.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '15px', width: '15px', height: '15px' },
    '@media only screen and (max-width:810px)': { fontSize: '14.5px', width: '14.5px', height: '14.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '14px', width: '14px', height: '14px' }
  },
  iconMd: {
    '@media only screen and (max-width:1920px)': { fontSize: '20px', width: '20px', height: '20px' },
    '@media only screen and (max-width:1543px)': { fontSize: '19px', width: '19px', height: '19px' },
    '@media only screen and (max-width:1280px)': { fontSize: '18px', width: '18px', height: '18px' },
    '@media only screen and (max-width:810px)': { fontSize: '17px', width: '17px', height: '17px' },
    '@media only screen and (max-width:390px)': { fontSize: '16px', width: '16px', height: '16px' }
  },
  iconLg: {
    '@media only screen and (max-width:1920px)': { fontSize: '24px', width: '24px', height: '24px' },
    '@media only screen and (max-width:1543px)': { fontSize: '23px', width: '23px', height: '23px' },
    '@media only screen and (max-width:1280px)': { fontSize: '22px', width: '22px', height: '22px' },
    '@media only screen and (max-width:810px)': { fontSize: '21px', width: '21px', height: '21px' },
    '@media only screen and (max-width:390px)': { fontSize: '20px', width: '20px', height: '20px' }
  }
};

const padding = {
  xs: {
    '@media only screen and (max-width:1920px)': { padding: '6px' },
    '@media only screen and (max-width:1543px)': { padding: '5.5px' },
    '@media only screen and (max-width:1280px)': { padding: '5px' },
    '@media only screen and (max-width:810px)': { padding: '4.5px' },
    '@media only screen and (max-width:390px)': { padding: '4px' }
  },
  s: {
    '@media only screen and (max-width:1920px)': { padding: '10px' },
    '@media only screen and (max-width:1543px)': { padding: '9.5px' },
    '@media only screen and (max-width:1280px)': { padding: '9px' },
    '@media only screen and (max-width:810px)': { padding: '8.5px' },
    '@media only screen and (max-width:390px)': { padding: '8px' }
  },
  m: {
    '@media only screen and (max-width:1920px)': { padding: '15px' },
    '@media only screen and (max-width:1543px)': { padding: '14.5px' },
    '@media only screen and (max-width:1280px)': { padding: '14px' },
    '@media only screen and (max-width:810px)': { padding: '13.5px' },
    '@media only screen and (max-width:390px)': { padding: '13px' }
  },
  l: {
    '@media only screen and (max-width:1920px)': { padding: '20px' },
    '@media only screen and (max-width:1543px)': { padding: '19.5px' },
    '@media only screen and (max-width:1280px)': { padding: '19px' },
    '@media only screen and (max-width:810px)': { padding: '18.5px' },
    '@media only screen and (max-width:390px)': { padding: '18px' }
  },
  xl: {
    '@media only screen and (max-width:1920px)': { padding: '24px' },
    '@media only screen and (max-width:1543px)': { padding: '23.5px' },
    '@media only screen and (max-width:1280px)': { padding: '23px' },
    '@media only screen and (max-width:810px)': { padding: '22.5px' },
    '@media only screen and (max-width:390px)': { padding: '22px' }
  },
  xxl: {
    '@media only screen and (max-width:1920px)': { padding: '30px' },
    '@media only screen and (max-width:1543px)': { padding: '29.5px' },
    '@media only screen and (max-width:1280px)': { padding: '29px' },
    '@media only screen and (max-width:810px)': { padding: '28.5px' },
    '@media only screen and (max-width:390px)': { padding: '28px' }
  },
  xxxl: {
    '@media only screen and (max-width:1920px)': { padding: '48px' },
    '@media only screen and (max-width:1543px)': { padding: '46px' },
    '@media only screen and (max-width:1280px)': { padding: '44px' },
    '@media only screen and (max-width:810px)': { padding: '42px' },
    '@media only screen and (max-width:390px)': { padding: '40px' }
  }
};

const margin = {
  xs: {
    '@media only screen and (max-width:1920px)': { margin: '6px' },
    '@media only screen and (max-width:1543px)': { margin: '5.5px' },
    '@media only screen and (max-width:1280px)': { margin: '5px' },
    '@media only screen and (max-width:810px)': { margin: '4.5px' },
    '@media only screen and (max-width:390px)': { margin: '4px' }
  },
  s: {
    '@media only screen and (max-width:1920px)': { margin: '10px' },
    '@media only screen and (max-width:1543px)': { margin: '9.5px' },
    '@media only screen and (max-width:1280px)': { margin: '9px' },
    '@media only screen and (max-width:810px)': { margin: '8.5px' },
    '@media only screen and (max-width:390px)': { margin: '8px' }
  },
  m: {
    '@media only screen and (max-width:1920px)': { margin: '15px' },
    '@media only screen and (max-width:1543px)': { margin: '14.5px' },
    '@media only screen and (max-width:1280px)': { margin: '14px' },
    '@media only screen and (max-width:810px)': { margin: '13.5px' },
    '@media only screen and (max-width:390px)': { margin: '13px' }
  },
  l: {
    '@media only screen and (max-width:1920px)': { margin: '20px' },
    '@media only screen and (max-width:1543px)': { margin: '19.5px' },
    '@media only screen and (max-width:1280px)': { margin: '19px' },
    '@media only screen and (max-width:810px)': { margin: '18.5px' },
    '@media only screen and (max-width:390px)': { margin: '18px' }
  },
  xl: {
    '@media only screen and (max-width:1920px)': { margin: '24px' },
    '@media only screen and (max-width:1543px)': { margin: '23.5px' },
    '@media only screen and (max-width:1280px)': { margin: '23px' },
    '@media only screen and (max-width:810px)': { margin: '22.5px' },
    '@media only screen and (max-width:390px)': { margin: '22px' }
  },
  xxl: {
    '@media only screen and (max-width:1920px)': { margin: '30px' },
    '@media only screen and (max-width:1543px)': { margin: '29.5px' },
    '@media only screen and (max-width:1280px)': { margin: '29px' },
    '@media only screen and (max-width:810px)': { margin: '28.5px' },
    '@media only screen and (max-width:390px)': { margin: '28px' }
  },
  '3xl': {
    '@media only screen and (max-width:1920px)': { margin: '48px' },
    '@media only screen and (max-width:1543px)': { margin: '46px' },
    '@media only screen and (max-width:1280px)': { margin: '44px' },
    '@media only screen and (max-width:810px)': { margin: '42px' },
    '@media only screen and (max-width:390px)': { margin: '40px' }
  }
};

const gap = {
  xs: {
    '@media only screen and (max-width:1920px)': { gap: '6px' },
    '@media only screen and (max-width:1543px)': { gap: '5.5px' },
    '@media only screen and (max-width:1280px)': { gap: '5px' },
    '@media only screen and (max-width:810px)': { gap: '4.5px' },
    '@media only screen and (max-width:390px)': { gap: '4px' }
  },
  s: {
    '@media only screen and (max-width:1920px)': { gap: '10px' },
    '@media only screen and (max-width:1543px)': { gap: '9.5px' },
    '@media only screen and (max-width:1280px)': { gap: '9px' },
    '@media only screen and (max-width:810px)': { gap: '8.5px' },
    '@media only screen and (max-width:390px)': { gap: '8px' }
  },
  m: {
    '@media only screen and (max-width:1920px)': { gap: '15px' },
    '@media only screen and (max-width:1543px)': { gap: '14.5px' },
    '@media only screen and (max-width:1280px)': { gap: '14px' },
    '@media only screen and (max-width:810px)': { gap: '13.5px' },
    '@media only screen and (max-width:390px)': { gap: '13px' }
  },
  l: {
    '@media only screen and (max-width:1920px)': { gap: '20px' },
    '@media only screen and (max-width:1543px)': { gap: '19.5px' },
    '@media only screen and (max-width:1280px)': { gap: '19px' },
    '@media only screen and (max-width:810px)': { gap: '18.5px' },
    '@media only screen and (max-width:390px)': { gap: '18px' }
  },
  xl: {
    '@media only screen and (max-width:1920px)': { gap: '24px' },
    '@media only screen and (max-width:1543px)': { gap: '23.5px' },
    '@media only screen and (max-width:1280px)': { gap: '23px' },
    '@media only screen and (max-width:810px)': { gap: '22.5px' },
    '@media only screen and (max-width:390px)': { gap: '22px' }
  },
  xxl: {
    '@media only screen and (max-width:1920px)': { gap: '30px' },
    '@media only screen and (max-width:1543px)': { gap: '29.5px' },
    '@media only screen and (max-width:1280px)': { gap: '29px' },
    '@media only screen and (max-width:810px)': { gap: '28.5px' },
    '@media only screen and (max-width:390px)': { gap: '28px' }
  },
  '3xl': {
    '@media only screen and (max-width:1920px)': { gap: '48px' },
    '@media only screen and (max-width:1543px)': { gap: '46px' },
    '@media only screen and (max-width:1280px)': { gap: '44px' },
    '@media only screen and (max-width:810px)': { gap: '42px' },
    '@media only screen and (max-width:390px)': { gap: '40px' }
  }
};

const components = {
  textField: {
    container: {
      position: "relative",
      width: "100%",
    },
    input: {
      ...combine(padding.s, padding.m, fontSizes2.body),
      borderWidth: "1px",
      borderColor: colors2.bleuPale,
      borderStyle: "solid",
      backgroundColor: colors2.blancGlacial,
      borderRadius: "10px",
      width: "100%",
      height: "40px",
      fontFamily: "\"Roboto\", sans-serif",
      color: colors2.bleuArdoise,
      outline: "none",
      color: colors2.bleuMarine,
      placeholder: {
        color: colors2.bleuMarine,
      },
      "&:hover": {
        borderColor: colors2.bleuElectrique,
        backgroundColor: colors2.blanc,
        "&::placeholder": {
          color: colors2.bleuElectrique,
        }
      },
      "&:focus": {
        borderColor: colors2.bleuElectrique,
        "&::placeholder": {
          color: colors2.bleuElectrique,
        }
      },
      "&:disabled": {
        backgroundColor: colors2.blancGlacial,
        borderColor: colors2.bleuPale,
        cursor: "not-allowed",

        "&::placeholder": {
          color: colors2.bleuArdoise,
        }
      },
    },
    inputError: {
      backgroundColor: colors2.rosePoudre,
      borderColor: colors2.roseElectrique,
    },
  },
  autocomplete: {
    container: {
      position: "relative",
      width: "100%",
    },
    inputContainer: {
      borderWidth: "1px",
      borderColor: colors2.bleuPale,
      borderStyle: "solid",
      alignItems: "center",
      backgroundColor: colors2.blancGlacial,
      borderRadius: "10px",
      display: "flex",
      flexDirection: "row",
      height: "40px",
      justifyContent: "space-between",
      ...combine(padding.s, padding.m),
      width: "100%",
      cursor: "pointer",
      transition: "all 0.2s ease-in-out",
      position: "relative",
    },
    input: {
      border: "none",
      outline: "none",
      width: "100%",
      fontFamily: "\"Roboto\", sans-serif",
      ...combine(fontSizes2.body),
      color: colors2.bleuArdoise,
      background: "transparent",
      "&::placeholder": {
        color: colors2.bleuArdoise,
        opacity: 1
      },
      "&:hover::placeholder": {
        color: colors2.bleuElectrique,
        opacity: 1
      }
    },
    iconContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: colors2.bleuArdoise,
      transition: "color 0.2s ease-in-out",
    },
    icon: {
      ...combine(iconSizes.iconLg),
      fill: "currentColor",
    },
    optionsList: {
      position: "absolute",
      top: "100%",
      left: 0,
      right: 0,
      marginTop: "5px",
      borderRadius: "10px",
      backgroundColor: colors2.blanc,
      boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
      zIndex: 10,
      maxHeight: "200px",
      overflowY: "auto",
    },
    option: {
      ...combine(padding.s, padding.m, fontSizes2.body),
      cursor: "pointer",
      fontFamily: "\"Roboto\", sans-serif",
      color: colors2.bleuArdoise,
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        backgroundColor: colors2.blancGlacial,
        color: colors2.bleuElectrique,
      }
    },
    optionSelected: {
      backgroundColor: colors2.blancGlacial,
      color: colors2.bleuElectrique,
    },
    noOptions: {
      ...combine(padding.s, padding.m, fontSizes2.body),
      cursor: "pointer",
      fontFamily: "\"Roboto\", sans-serif",
      color: colors2.bleuArdoise,
      fontStyle: "italic",
      textAlign: "center"
    },
    hover: {
      borderColor: colors2.bleuElectrique,
      backgroundColor: colors2.blanc,
      "& $iconContainer": {
        color: colors2.bleuElectrique,
      }
    },
    focus: {
      borderColor: colors2.bleuElectrique,
      backgroundColor: colors2.blanc,
      "& $iconContainer": {
        color: colors2.bleuElectrique,
      }
    },
    error: {
      backgroundColor: colors2.rosePoudre,
      borderColor: colors2.roseElectrique,
    }
  },
  AuthGoogleLinkedin: {
    button: {
      ...combine(padding.s, padding.m, gap.s),
      borderWidth: "1px",
      borderColor: "transparent",
      borderStyle: "solid",
      alignContent: "center",
      backgroundColor: colors2.blancGlacial,
      borderRadius: "7px",
      display: "flex",
      flexDirection: "row",
      height: "min-content",
      position: "relative",
      width: "100%",
      overflow: "hidden",
      placeItems: "center",
      "&:hover": {
        borderWidth: "1px",
        borderColor: colors2.bleuElectrique,
        backgroundColor: colors2.bleuPale,
      },
      "&:disabled": {
        backgroundColor: colors2.blancGlacial,
        cursor: "not-allowed",
        color: colors2.bleuArdoise,
        "&:hover": {
          backgroundColor: colors2.blancGlacial,
        },
      },
    },
    icon: {
      ...combine(iconSizes.iconLg),
      position: "relative",
      overflow: "visible",
    }
  },
  checkbox: {
    container: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      userSelect: "none",
      ...combine(gap.xs),
    },
    input: {
      position: "absolute",
      opacity: 0,
      cursor: "pointer",
      height: 0,
      width: 0,
    },
    checkmark: {
      ...combine(iconSizes.iconSm),
      backgroundColor: colors2.blanc,
      border: `1px solid ${colors2.bleuPale}`,
      borderRadius: "3px",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: colors2.bleuElectrique,
        backgroundColor: colors2.blancGlacial,
      },
    },
    checkmarkChecked: {
      backgroundColor: colors2.bleuElectrique,
      borderColor: colors2.bleuElectrique,
      "&:hover": {
        backgroundColor: colors2.bleuSaphir,
        borderColor: colors2.bleuSaphir,
      },
    },
    icon: {
      ...combine(fontSizes2.body),
      color: colors2.blanc,
      display: "none",
    },
    iconChecked: {
      display: "block",
    },
    label: {
      ...combine(fontSizes2.body),
      fontWeight: "500",
      color: colors2.bleuMarine,
      cursor: "pointer",
      fontFamily: "\"Montserrat\", sans-serif",
    },
    labelDisabled: {
      color: colors2.bleuArdoise,
      cursor: "not-allowed",
    },
    disabled: {
      cursor: "not-allowed",
      backgroundColor: colors2.blancGlacial,
      borderColor: colors2.bleuPale,
      "&:hover": {
        backgroundColor: colors2.blancGlacial,
        borderColor: colors2.bleuPale,
      },
    },
  },
  select: {
    container: {
      position: "relative",
      width: "100%",
    },
    input: {
      ...combine(padding.s, padding.m),
      borderWidth: "1px",
      borderColor: colors2.bleuPale,
      borderStyle: "solid",
      alignItems: "center",
      backgroundColor: colors2.blancGlacial,
      borderRadius: "10px",
      display: "flex",
      flexDirection: "row",
      height: "40px",
      justifyContent: "space-between",
      width: "100%",
      cursor: "pointer",
      position: "relative",
      color: colors2.bleuArdoise,
      "&:hover": {
        borderColor: colors2.bleuElectrique,
        backgroundColor: colors2.blanc,
        "&::placeholder": {
          color: colors2.bleuElectrique,
        }
      },
      "&:focus": {
        borderColor: colors2.bleuElectrique,
        "&::placeholder": {
          color: colors2.bleuElectrique,
        }
      },
      "&:disabled": {
        backgroundColor: colors2.blancGlacial,
        borderColor: colors2.bleuPale,
        cursor: "not-allowed",
        "&::placeholder": {
          color: colors2.bleuArdoise,
        }
      },
    },
    inputField: {
      border: "none",
      outline: "none",
      width: "100%",
      fontFamily: "\"Roboto\", sans-serif",
      ...combine(fontSizes2.body),
      color: colors2.bleuArdoise,
      background: "transparent",
      "&::placeholder": {
        color: colors2.bleuArdoise,
        opacity: 1
      },
      "&:hover::placeholder": {
        color: colors2.bleuElectrique,
        opacity: 1
      }
    },
    arrow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: colors2.bleuArdoise,
    },
    hover: {
      borderColor: colors2.bleuElectrique,
      backgroundColor: colors2.blanc,
      "& $arrow": {
        color: colors2.bleuElectrique,
      }
    },
    focus: {
      borderColor: colors2.bleuElectrique,
      backgroundColor: colors2.blanc,
      "& $arrow": {
        color: colors2.bleuElectrique,
      }
    },
    error: {
      backgroundColor: colors2.rosePoudre,
      borderColor: colors2.roseElectrique,
    },
    dropdown: {
      position: "absolute",
      top: "100%",
      left: 0,
      right: 0,
      marginTop: "5px",
      borderRadius: "10px",
      backgroundColor: colors2.blanc,
      boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
      zIndex: 10,
      maxHeight: "200px",
      overflowY: "auto",
    },
    option: {
      ...combine(padding.s, padding.m, fontSizes2.body),
      cursor: "pointer",
      fontFamily: "\"Roboto\", sans-serif",
      color: colors2.bleuArdoise,
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        backgroundColor: colors2.blancGlacial,
        color: colors2.bleuElectrique,
      }
    },
    optionSelected: {
      backgroundColor: colors2.blancGlacial,
      color: colors2.bleuElectrique,
    },
    optionText: {
      display: "block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }
  },
  phoneInput: {
    container: {
      ...combine(padding.s, padding.m, fontSizes2.body),
      position: "relative",
      width: "100%",
      display: "flex",
      alignItems: "center",
      backgroundColor: colors2.blancGlacial,
      borderRadius: "10px",
      border: `1px solid ${colors2.bleuPale}`,
      height: "40px",
      fontFamily: "\"Roboto\", sans-serif",
      color: colors2.bleuMarine,
      outline: "none",
      "&:hover": {
        borderColor: colors2.bleuElectrique,
        backgroundColor: colors2.blanc,
      },
      "&:focus-within": {
        borderColor: colors2.bleuElectrique,
        backgroundColor: colors2.blanc,
      },
      "&:disabled": {
        backgroundColor: colors2.blancGlacial,
        borderColor: colors2.bleuPale,
        cursor: "not-allowed",
      },
    },
    countrySelector: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      minWidth: "70px",
    },
    input: {
      ...combine(fontSizes2.body),
      border: "none",
      outline: "none",
      backgroundColor: "transparent",
      color: colors2.bleuMarine,
      fontFamily: "\"Roboto\", sans-serif",
      flex: 1,
      padding: 0,
      margin: 0,
    },
    inputError: {
      backgroundColor: colors2.rosePoudre,
      borderColor: colors2.roseElectrique,
    },
    dropdown: {
      position: "absolute",
      top: "100%",
      left: 0,
      backgroundColor: colors2.blanc,
      border: `1px solid ${colors2.bleuPale}`,
      borderRadius: "10px",
      boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
      zIndex: 1000,
      maxHeight: "200px",
      overflowY: "auto",
      marginTop: "4px",
      width: "max-content",
    },
    option: {
      ...combine(padding.s, padding.m, fontSizes2.body),
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      backgroundColor: "transparent",
      borderBottom: `1px solid ${colors2.blancGlacial}`,
      whiteSpace: "nowrap",
      transition: "background-color 0.2s ease",
      fontFamily: "\"Roboto\", sans-serif",
      color: colors2.bleuMarine,
      fontWeight: 400,
      "&:hover": {
        backgroundColor: colors2.blancGlacial,
      },
    },
    optionSelected: {
      backgroundColor: colors2.blancGlacial,
    },
    flag: {
      width: "20px",
      height: "15px",
      borderRadius: "2px",
      objectFit: "cover",
    },
    dialCode: {
      ...combine(fontSizes2.body, padding.s),
      color: colors2.bleuMarine,
      fontWeight: 400,
    },
    countryName: {
      ...combine(fontSizes2.body),
      color: colors2.bleuArdoise,
      flex: 1,
    },
    arrow: {
      ...combine(fontSizes2.body),
      color: colors2.bleuArdoise,
    },
    error: {
      backgroundColor: colors2.rosePoudre,
      borderColor: colors2.roseElectrique,
    },
  },
};

const theme = {
  colors2,
  fontSizes,
  fontSizes2,
  spacing,
  padding,
  iconSizes,
  margin,
  gap,
  components,
};

export default theme;